"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports["default"] = void 0;

var _createSvgIcon = _interopRequireDefault(require("../createSvgIcon"));

var _Dragable = _interopRequireDefault(require("@rsuite/icon-font/lib/action/Dragable"));

// Generated by script, don't edit it please.
var Dragable = (0, _createSvgIcon["default"])({
  as: _Dragable["default"],
  ariaLabel: 'dragable',
  category: 'action',
  displayName: 'Dragable'
});
var _default = Dragable;
exports["default"] = _default;
module.exports = exports.default;